module.exports = __webpack_public_path__ + "img/serialportsetup.3a92daf3.png";